<section>
    <div class="container-fluid">
        <div class="row">
            <div class="col">
                <p class="display-1 text-center">WEBSITE UNDER <br> CONSTRUCTION</p>
            </div>
        </div>
    </div>
</section>